import { makeStyles } from '@material-ui/core/styles';
import { grey_medium } from '@theme/customTheme';

export const useStyles = makeStyles(theme => ({
  createAccount: {
    margin: '40px 250px 0px 250px',
    '@media (max-width:780px)': {
      margin: '40px 0px 0px',
    },
  },

  heading: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  headingSubTitle: {
    fontFamily: 'Open Sans',
    color: grey_medium,
    fontWeight: 'bold',
    fontSize: '16px',
    lineHeight: '24px',
    textTransform: 'uppercase',
  },
  stepBox: {
    marginBottom: '48px',
    '@media (max-width:480px)': {
      marginBottom: '60px',
    },
  },
  stepTwoBox: {
    maxWidth: '736px',
    margin: '0 auto',
  },
  pricePageTitleWrapper: {
    marginBottom: '40px',
    marginTop: '20px',
  },
  pricePageTitle: {
    paddingBottom: 12,
    '&::before': {
      position: 'absolute',
      content: "' '",
      width: 40,
      height: 2,
      backgroundColor: '#000000',
      bottom: 30,
      left: 'calc(50% - 20px)',
    },
  },
}));
